import {get, post} from "./http_client";
import {api_vlog_comments_path, server_vapid_public_key_path, webauthn_challenge_api_my_server_path} from "../routes";

export const vapidPublicKey = () => get({ url: server_vapid_public_key_path() });
export const webauthnChallenge = () => get({ url: webauthn_challenge_api_my_server_path() })